import { useAuth } from '../providers/AuthProvider'
import { hasPermission, isAdmin } from '../lib/permissions'

export function usePermissions() {
  const { user } = useAuth()
  const permissions = user?.role?.permissions ?? {}

  return {
    hasPermission: (resource: string, action?: string) => hasPermission(permissions, resource, action),
    isAdmin: () => isAdmin(permissions),
    permissions,
  }
}
